import information from './claimForm/information.vue';
import materials from './claimForm/materials.vue';
export default {
  components: {
    information,
    materials
  },
  data() {
    return {
      current: 0,
      stepStyle: {}
    };
  },
  methods: {
    nextFun() {
      this.current++;
    }
  }
};